/*
 * ET - FAQ (sections/et-faq.liquid)
 * Progressive enhancement for the <details> accordion: height animation, "only one open at a time"
 * (data-et-faq-single) with animated closing, and opening the selected block in the theme editor.
 */
(function () {
  'use strict';

  // Two FAQ sections on one page include this file twice; only the first copy binds.
  if (document.documentElement.hasAttribute('data-et-faq-script')) return;
  document.documentElement.setAttribute('data-et-faq-script', '');

  var ROOT_SELECTOR = '[data-et-faq]';
  var ITEM_SELECTOR = '.et-faq__item';
  var QUESTION_SELECTOR = '.et-faq__question';
  var READY_ATTRIBUTE = 'data-et-faq-ready';
  var CLOSING_CLASS = 'et-faq__item--closing';
  var DURATION = 300;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  var controllers = new Map();
  var animations = new WeakMap();
  var reducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function getQuestion(item) {
    var first = item.firstElementChild;
    return first && first.matches(QUESTION_SELECTOR) ? first : null;
  }

  function stopAnimation(item) {
    var animation = animations.get(item);
    if (!animation) return;
    animations.delete(item);
    animation.cancel();
  }

  function animateHeight(item, from, to, done) {
    var canAnimate =
      typeof item.animate === 'function' && !(reducedMotion && reducedMotion.matches) && Math.abs(from - to) > 0.5;

    if (!canAnimate) {
      done();
      return;
    }

    var animation = item.animate({ height: [from + 'px', to + 'px'] }, { duration: DURATION, easing: EASING });
    animations.set(item, animation);

    animation.onfinish = function () {
      if (animations.get(item) !== animation) return;
      animations.delete(item);
      done();
    };
  }

  function Accordion(root) {
    this.root = root;
    this.single = root.hasAttribute('data-et-faq-single');
    this.onClick = this.onClick.bind(this);
    this.onToggle = this.onToggle.bind(this);

    // Native `name` exclusivity would close siblings instantly; the script takes over so they animate.
    if (this.single) {
      this.getItems().forEach(function (item) {
        item.removeAttribute('name');
      });
    }

    root.addEventListener('click', this.onClick);
    root.addEventListener('toggle', this.onToggle, true);
  }

  Accordion.prototype.getItems = function () {
    return Array.prototype.slice.call(this.root.querySelectorAll(ITEM_SELECTOR));
  };

  Accordion.prototype.isExpanded = function (item) {
    return item.open && !item.classList.contains(CLOSING_CLASS);
  };

  Accordion.prototype.open = function (item) {
    var from = item.getBoundingClientRect().height;

    stopAnimation(item);
    item.classList.remove(CLOSING_CLASS);
    item.open = true;

    animateHeight(item, from, item.getBoundingClientRect().height, function () {});

    if (this.single) this.closeOthers(item);
  };

  Accordion.prototype.close = function (item) {
    var question = getQuestion(item);
    if (!question) return;

    var from = item.getBoundingClientRect().height;

    stopAnimation(item);
    item.classList.add(CLOSING_CLASS);

    animateHeight(item, from, question.getBoundingClientRect().height, function () {
      item.classList.remove(CLOSING_CLASS);
      item.open = false;
    });
  };

  Accordion.prototype.closeOthers = function (current) {
    var self = this;
    this.getItems().forEach(function (item) {
      if (item !== current && self.isExpanded(item)) self.close(item);
    });
  };

  Accordion.prototype.onClick = function (event) {
    var question = event.target.closest(QUESTION_SELECTOR);
    if (!question || !this.root.contains(question)) return;

    var item = question.parentElement;
    if (!item || !item.matches(ITEM_SELECTOR)) return;

    event.preventDefault();

    if (this.isExpanded(item)) {
      this.close(item);
    } else {
      this.open(item);
    }
  };

  // Native toggles (find-in-page, editor): keep single-open mode consistent.
  Accordion.prototype.onToggle = function (event) {
    var item = event.target;
    if (!item.matches || !item.matches(ITEM_SELECTOR) || animations.has(item)) return;
    if (item.open && this.single) this.closeOthers(item);
  };

  Accordion.prototype.reveal = function (item) {
    if (!this.isExpanded(item)) this.open(item);
  };

  Accordion.prototype.destroy = function () {
    this.root.removeEventListener('click', this.onClick);
    this.root.removeEventListener('toggle', this.onToggle, true);
    this.getItems().forEach(stopAnimation);
  };

  function init(scope) {
    var container = scope || document;
    var roots = container.matches && container.matches(ROOT_SELECTOR) ? [container] : [];
    roots = roots.concat(Array.prototype.slice.call(container.querySelectorAll(ROOT_SELECTOR)));

    roots.forEach(function (root) {
      if (controllers.has(root) || root.hasAttribute(READY_ATTRIBUTE)) return;
      root.setAttribute(READY_ATTRIBUTE, '');
      controllers.set(root, new Accordion(root));
    });
  }

  function destroy(scope) {
    controllers.forEach(function (controller, root) {
      if (scope === root || scope.contains(root)) {
        controller.destroy();
        controllers.delete(root);
        root.removeAttribute(READY_ATTRIBUTE);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target;
    if (!item || !item.matches || !item.matches(ITEM_SELECTOR)) return;

    var root = item.closest(ROOT_SELECTOR);
    var controller = root ? controllers.get(root) : null;
    if (controller) controller.reveal(item);
  });
})();
